export default "__VITE_ASSET__BBLr818D__"